import { Organizacia as OrganizaciaGenerated } from 'elegislativa-frontend-ts-axios';
import Uuid from '../Uuid';

export default interface Organizacia {
  uuid: Uuid,
  nazov: string,
  uplnyNazov?: string,
  email?: string,
  ldapUuid?: string,
  skratenyNazov?: string,
  nazovEmail?: string,
}

function mapOrganizacia(organizacia: OrganizaciaGenerated): Organizacia | undefined {
  if (!organizacia) {
    return undefined;
  }
  return {
    uuid: organizacia.uuid,
    skratenyNazov: organizacia.skratenyNazov,
    nazov: organizacia.nazov,
    uplnyNazov: organizacia.skratenyNazov ? `${organizacia.skratenyNazov} (${organizacia.nazov})` : organizacia.nazov,
    ldapUuid: organizacia.ldapUuid,
    email: organizacia.email,
    nazovEmail: `${organizacia.nazov} (${organizacia.email})`,
  };
}

export { Organizacia, mapOrganizacia };
